import React from 'react';
import { Helmet } from 'react-helmet';
import { Calendar as CalendarIcon, Plus, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';

export default function AgendaSystemPage() {
  const { toast } = useToast();

  const handleAction = () => {
    toast({
      title: "Calendário em Desenvolvimento",
      description: "🚧 This feature isn't implemented yet—but don't worry! You can request it in your next prompt! 🚀",
    });
  };

  return (
    <div className="p-8 max-w-7xl mx-auto space-y-6 flex flex-col h-[calc(100vh-100px)]">
      <Helmet>
        <title>Agenda - PROVATIO</title>
      </Helmet>

      <div className="flex items-center justify-between shrink-0">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 rounded-lg text-[#193D6D]">
            <CalendarIcon size={24} />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-[#193D6D]">Agenda de Eventos</h1>
            <p className="text-slate-500">Perícias, audiências e reuniões centralizadas.</p>
          </div>
        </div>
        <Button onClick={handleAction} className="bg-[#193D6D] hover:bg-blue-800 text-white">
          <Plus className="w-4 h-4 mr-2" /> Novo Evento
        </Button>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 flex-1 flex flex-col overflow-hidden">
        <div className="p-4 border-b flex items-center justify-between bg-slate-50">
          <div className="flex items-center gap-4">
            <Button variant="outline" size="icon" onClick={handleAction}><ChevronLeft className="w-4 h-4" /></Button>
            <h2 className="text-lg font-semibold text-slate-800">Novembro 2023</h2>
            <Button variant="outline" size="icon" onClick={handleAction}><ChevronRight className="w-4 h-4" /></Button>
          </div>
          <div className="flex bg-slate-200 p-1 rounded-lg">
            <button className="px-3 py-1 bg-white shadow-sm rounded-md text-sm font-medium" onClick={handleAction}>Mês</button>
            <button className="px-3 py-1 text-sm font-medium text-slate-600 hover:bg-slate-300 rounded-md transition-colors" onClick={handleAction}>Semana</button>
            <button className="px-3 py-1 text-sm font-medium text-slate-600 hover:bg-slate-300 rounded-md transition-colors" onClick={handleAction}>Dia</button>
          </div>
        </div>
        
        <div className="flex-1 p-8 flex items-center justify-center bg-slate-50/50">
          <div className="text-center text-slate-400">
            <CalendarIcon className="w-16 h-16 mx-auto mb-4 opacity-20" />
            <p className="text-lg">Visualização de Calendário Integrado em Breve</p>
            <Button variant="outline" className="mt-4" onClick={handleAction}>Sincronizar Eventos</Button>
          </div>
        </div>
      </div>
    </div>
  );
}